import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Navbar from './components/Navbar.jsx';
import Footer from './components/Footer';
import RouteSeo from './components/RouteSeo.jsx';
import Home from './pages/Home.jsx';
// // import ModernHome from './pages/ModernHome.jsx';
import Login from './pages/Login.jsx';
import Register from './pages/Register.jsx';
import Profile from './pages/Profile.jsx';
import SejourPage from './pages/Sejour.jsx';
import CircuitPage from './pages/Circuit.jsx';
import TransportPage from './pages/Transport.jsx';
import Contact from './pages/Contact.jsx';
import AdminPanel from './pages/admin/AdminPanel.js';
import InvoiceRequest from './pages/InvoiceRequest.jsx';
import ReservationSuccess from './pages/ReservationSuccess.jsx';
import ReservationCancel from './pages/ReservationCancel.jsx';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentFailed from './pages/PaymentFailed';
import ProtectedAdminRoute from './components/ProtectedAdminRoute.js';
import DebugAuth from './components/DebugAuth.js';

import { useAuth } from './contexts/AuthContext';
import './App.css';
import PolitiqueCookies from './pages/legal/cookies.tsx';
import MentionsLegales from './pages/legal/mentions.tsx';
import ConditionsUtilisation from './pages/legal/terms.tsx';
import PolitiqueConfidentialite from './pages/legal/privacy.tsx';
import Services from './pages/Services.jsx';
import HotelDetails from './pages/HotelDetails.jsx';
import CircuitDetail from './pages/CircuitDetail.jsx';
import CircuitSurMesure from './pages/CircuitSurMesure.jsx';
import Location from './pages/Location.jsx';
import GuidedTours from './pages/GuidedTours.jsx';
import ProSection from './pages/ProSection.jsx';
import AgencyPartnership from './pages/AgencyPartnership.jsx';
import EditListing from './components/EditListing.jsx';
import About from './pages/About.jsx';
import Help from './pages/Help.jsx';
import Cancellation from './pages/Cancellation.jsx';
import Safety from './pages/Safety.jsx';
import CGV from "./pages/CGV";
import PaiementSecurise from "./pages/PaiementSecurise";

// Composant pour protéger les routes qui nécessitent une authentification
const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return <div>Chargement...</div>;
  }

  if (!currentUser) {
    // Rediriger vers la page de connexion avec l'emplacement actuel
    return <Navigate to="/login" replace />;
  }

  return children;
};

function AppContent() {
  const location = useLocation();
  const hideLayout = location.pathname === '/login' || location.pathname === '/register';
  const hidefooter = location.pathname === '/admin' || location.pathname === '/adminpanel';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Récupérer la langue depuis localStorage ou utiliser le français par défaut
  const [language, setLanguage] = useState(() => localStorage.getItem('language') || 'fr');

  // Stocker la langue dans localStorage à chaque changement
  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  return (
    <>
      {/* SEO dynamique par route (titre, meta, Open Graph, JSON-LD) */}
      <RouteSeo />
      {/* Configuration du Toaster pour les notifications */}
      <Toaster
        position="bottom-center"
        reverseOrder={false}
        gutter={10}
        toastOptions={{
          duration: 4000,
          style: {
            background: '#ffffff',
            color: '#1f2937',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.06)',
            borderRadius: '14px',
            padding: '12px 14px',
            fontSize: '14px',
            fontWeight: 500,
            maxWidth: '420px',
          },
          success: {
            duration: 3500,
            iconTheme: { primary: '#10b981', secondary: '#ffffff' },
            style: { borderLeft: '4px solid #10b981' },
          },
          error: {
            duration: 6000,
            iconTheme: { primary: '#ef4444', secondary: '#ffffff' },
            style: { borderLeft: '4px solid #ef4444' },
          },
          loading: {
            iconTheme: { primary: '#f59e0b', secondary: '#ffffff' },
            style: { borderLeft: '4px solid #f59e0b' },
          },
        }}
      />
      {!hideLayout && <Navbar language={language} setLanguage={setLanguage} />}
      <div className="min-h-screen flex flex-col justify-between">
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<Home language={language} setLanguage={setLanguage} />} />
            <Route path="/services" element={<Services language={language} setLanguage={setLanguage} />} />
            {/* <Route path="/" element={<ModernHome language={language} setLanguage={setLanguage} />} /> */}
            <Route path="/classic" element={<Home language={language} setLanguage={setLanguage} />} />
            <Route path="/login" element={<Login language={language} />} />
            <Route path="/register" element={<Register language={language} />} />
            <Route path="/debug-auth" element={<DebugAuth />} />
            <Route path='/sejour' element={<SejourPage language={language} setLanguage={setLanguage} />} />
            <Route path='/sejour/:id' element={<HotelDetails language={language} />} />
            <Route path='/circuit' element={<CircuitPage language={language} setLanguage={setLanguage} />} />
            <Route path='/circuit/:id' element={<CircuitDetail language={language} setLanguage={setLanguage} />} />
            <Route path='/circuit-sur-mesure' element={<CircuitSurMesure language={language} setLanguage={setLanguage} />} />
            <Route path="/guided-tours" element={<GuidedTours language={language} />} />
            <Route path="/location" element={<Location language={language} />} />
            <Route path="/pro" element={<ProSection language={language} />} />
            <Route path="/pro/edit-listing/:id" element={<EditListing language={language} />} />
            <Route path="/agency-partnership" element={<AgencyPartnership language={language} />} />
            <Route path='/transport' element={<TransportPage language={language} setLanguage={setLanguage} />} />
            <Route path='/contact' element={<Contact language={language} setLanguage={setLanguage} />} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedAdminRoute><AdminPanel /></ProtectedAdminRoute>} />
            <Route path='/legal/cookies' element={<PolitiqueCookies language={language} />} />
            <Route path="/legal/mentions" element={<MentionsLegales language={language} />} />
            <Route path="/legal/terms" element={<ConditionsUtilisation language={language} />} />
            <Route path="/legal/privacy" element={<PolitiqueConfidentialite language={language} />} />
            <Route path="/invoice-request/:id/:type" element={<InvoiceRequest />} />
            <Route path="/reservation/success" element={<ReservationSuccess language={language} />} />
            <Route path="/reservation-success" element={<ReservationSuccess language={language} />} />
            {/* New CMI Payment Success Page */}
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />

            {/* New CMI Payment Failed Page */}
            <Route path="/payment-failed" element={<PaymentFailed />} />
            <Route path="/payment-fail" element={<PaymentFailed />} />


            <Route path="/reservation/cancel" element={<ReservationCancel language={language} />} />
            <Route path="/about" element={<About language={language} />} />
            <Route path="/help" element={<Help language={language} />} />
            <Route path="/cancellation" element={<Cancellation language={language} />} />
            <Route path="/safety" element={<Safety language={language} />} />
            <Route path="/cgv" element={<CGV language={language} />} />
            <Route path="/paiement-securise" element={<PaiementSecurise language={language} />} />
          </Routes>
        </div>
        {!hideLayout && !hidefooter && <Footer language={language} />}
      </div>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
